const CONSTANTS = {
  MODAL_BACK_DROP: [
    {
      visible: { opacity: 1 },
      hidden: { opacity: 0 },
    },
  ],
  MODAL_ANIMATE: [
    {
      visible: { opacity: 1 },
      hidden: { opacity: 0 },
    },
  ],
  COMPANY_NAME: "2MNordic",
};

export { CONSTANTS };
